import { DateTime } from 'luxon';
import { useEffect } from 'react';

import { useLocalStorageJSON } from 'common/hooks';

type ExperienceToggleState = {
  enabled: boolean;
  expires: string | null;
};

export const useToggleNewExperience = () => {
  const [newExperience, setNewExperience] = useLocalStorageJSON<ExperienceToggleState>('new_experience', {
    enabled: true,
    expires: null,
  });

  const toggleExperience = () => {
    const newValue = newExperience.enabled === true ? false : true;
    // expires in 1 hour if set to false
    const expires = newValue === false ? DateTime.now().plus({ hours: 1 }).toISO() : null;
    setNewExperience({
      enabled: newValue,
      expires,
    });

    if (newValue === false) {
      window.location.href = window.location.href.replace('/experience', '');
    } else {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (newExperience.enabled === false && newExperience.expires) {
      const expirationDate = DateTime.fromISO(newExperience.expires);
      const interval = setInterval(
        () => {
          if (DateTime.now() > expirationDate) {
            setNewExperience({
              enabled: true,
              expires: null,
            });
            clearInterval(interval);
          }
        },
        5 * 60 * 1000,
      );
      return () => clearInterval(interval);
    }

    return undefined;
  }, [newExperience.enabled, newExperience.expires, setNewExperience]);

  return {
    isNewExperienceEnabledStored: newExperience.enabled === true,
    toggleExperience,
  };
};
